import { useEffect } from 'react';
import { useAuth } from './hooks';
import { setAccessTokenGetter } from '@/services/api';

/**
 * Hook to integrate authentication with API client
 * This should be called at the app root level
 */
export function useApiAuth(): void {
  const { getAccessToken } = useAuth();

  useEffect(() => {
    // Set the token getter for the API client
    setAccessTokenGetter(async () => {
      try {
        return await getAccessToken();
      } catch (error) {
        console.error('Failed to get access token for API:', error);
        return null;
      }
    });
  }, [getAccessToken]);
}
